<mat-card
  class="appointment-type-card"
  [class.selected]="selected"
  (click)="onSelect()"
  matRipple
  role="button"
  [attr.aria-pressed]="selected"
>
  <div class="appointment-type-content">
    <h4>{{ type.title }}</h4>
    <p *ngIf="type.description">{{ type.description }}</p>
  </div>
  <mat-icon class="selected-icon" *ngIf="selected">check_circle</mat-icon>
</mat-card>
